import React, { useEffect, useMemo, useState } from 'react';
import { Menu, Tooltip } from 'antd';
import {
  IoCheckmarkDoneOutline,
  IoPeopleOutline,
  IoTrendingUp,
  IoSettingsOutline,
  IoHomeOutline,
  IoAppsOutline,
} from 'react-icons/io5';
import { MdCallSplit, MdFormatListBulleted, MdOutlineGroups, MdOutlineDashboard } from 'react-icons/md';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { basePath, redirectToAngular } from '../utilities/utility';
import { getLoginBusinessId } from '../services/auth-details-service';
import { getBusinessDetails } from '../services/business-details-service';
import { getSession } from '../services/storage-service';
import './menu-items-2.0.css';

function MenueItems({ darkMode, topMenu }) {
  const params = useParams();
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath?.split('/') || [];
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'home'}`] : [],
  );
  const userBusinessId = getLoginBusinessId();
  const businessDetails = getBusinessDetails();
  const [userAccountRoleType, setUserAccountRoleType] = useState('');
  const bizUserAccountObj = getSession(`${userBusinessId}_biz_Accocunt_user_obj`, true);

  const baseUrl = basePath();
  const { bizCode } = useParams();

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const onClickSettings = () => {
    redirectToAngular(bizCode, 'settings/service');
  };

  useEffect(() => {
    setUserAccountRoleType(bizUserAccountObj?.roleType);
  }, [bizUserAccountObj]);

  const defaultMenuSelectedKeys = useMemo(() => {
    switch (pathName) {
      case `/home/${params?.bizCode}/business/dashboard`:
        return 'home';
      case `/home/${params?.bizCode}/app/dashboards`:
        return 'insights';
      case `/home/${params?.bizCode}/apps`:
        return 'apps';
      case `/home/${params?.bizCode}/settings/DFC/flowList`:
        return 'flows';
      case `/home/${params?.bizCode}/tasks/taskslist`:
        return 'tasks';
      case `/home/${params?.bizCode}/teams`:
        return 'teams';
      case `/home/${params?.bizCode}/reports`:
        return 'reports';
      case `/home/${params?.bizCode}/accounts`:
        return 'accounts';
      case `/home/${params?.bizCode}/activity`:
        return 'activity';
      default:
        return pathName?.includes('services') ? 'apps' : '';
    }
  }, [pathName]);

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
      selectedKeys={[defaultMenuSelectedKeys]}
    >
      <Menu.Item
        icon={
          !topMenu && (
            <Tooltip title="Home" placement="right" overlayStyle={{ zIndex: 10000 }}>
            <NavLink className="menuItem-iocn" to={`${baseUrl}/business/dashboard`}>
                <IoHomeOutline className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
              </NavLink>
            </Tooltip>
          )
        }
        key="home"
      />
          <Menu.Item
            icon={
            !topMenu && (
              <Tooltip title="Insights" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/app/dashboards`}>
                  <MdOutlineDashboard
                    className="icon_style"
                    style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }}
                  />
                </NavLink>
              </Tooltip>
              )
            }
            key="insights"
      />
      <Menu.Item
        icon={
          !topMenu && (
            <Tooltip title="Apps" placement="right" overlayStyle={{ zIndex: 10000 }}>
            <NavLink className="menuItem-iocn" to={`${baseUrl}/apps`}>
                <IoAppsOutline className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
              </NavLink>
            </Tooltip>
          )
        }
        key="apps"
      />
      {userAccountRoleType === 'OWNER' && (
          <Menu.Item
            icon={
            !topMenu && (
              <Tooltip title="Flows" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/settings/DFC/flowList`}>
                  <MdCallSplit className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
                </NavLink>
              </Tooltip>
              )
            }
            key="flows"
          />
        )}

          <Menu.Item
            icon={
            !topMenu && (
              <Tooltip title="Tasks" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/tasks/taskslist`}>
                  <IoCheckmarkDoneOutline
                    className="icon_style"
                    style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }}
                  />
                </NavLink>
              </Tooltip>
              )
            }
            key="tasks"
      />
      {userAccountRoleType !== 'NORMAL' &&
        <Menu.Item
          icon={
            !topMenu && (
              <Tooltip title="Teams" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/teams`}>
                  <MdOutlineGroups className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
                </NavLink>
              </Tooltip>
            )
          }
          key="teams"
        />
      }
      {userAccountRoleType === 'OWNER' && (
          <Menu.Item
            icon={
              !topMenu && (
                <Tooltip title="Reports" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/reports`}>
                  <MdFormatListBulleted
                    className="icon_style"
                      style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }}
                  />
                  </NavLink>
                </Tooltip>
              )
            }
            key="reports"
          />
        )
      }

      {
        userAccountRoleType === 'OWNER' && (
          <Menu.Item
            icon={
              !topMenu && (
                <Tooltip title="Accounts" placement="right" overlayStyle={{ zIndex: 10000 }}>
                  <NavLink className="menuItem-iocn" to={`${baseUrl}/accounts`}>
                    <IoPeopleOutline className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
                  </NavLink>
                </Tooltip>
              )
            }
            key="accounts"
          />
        )
      }
      {userAccountRoleType === 'ADMIN' && (
          <Menu.Item
            icon={
                !topMenu && (
                  <Tooltip title="Accounts" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/accounts/myinvites`}>
                      <IoPeopleOutline className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
                    </NavLink>
                  </Tooltip>
              )
            }
            key="accounts"
          />
        )
      }
      {
        userAccountRoleType === 'OWNER' && (
          <Menu.Item
            icon={
              !topMenu && (
                <Tooltip title="Activity" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <NavLink className="menuItem-iocn" to={`${baseUrl}/activity`}>
                    <IoTrendingUp className="icon_style" style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }} />
                  </NavLink>
                </Tooltip>
              )
            }
            key="activity"
          />
        )
      }

      {
        userAccountRoleType === 'OWNER' && (
          <Menu.Item
            icon={
              !topMenu && (
                <Tooltip title="Settings" placement="right" overlayStyle={{ zIndex: 10000 }}>
                <a className="menuItem-iocn" onClick={onClickSettings}>
                  <IoSettingsOutline
                    className="icon_style"
                      style={{ color: businessDetails?.styleInfo?.menuIconsColor || '#6D6D6D' }}
                  />
                  </a>
                </Tooltip>
              )
            }
            key="settings"
          />
        )
      }
    </Menu >
  );
}

MenueItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
};

export default MenueItems;
